import type PersonaLinkingState from './state/personaLinkingState';
import type PrivateDLLoadingState from './state/privateDLLoadingState';
import type DeletePersonaState from './state/deletePersonaState';
import type RestoreContactsState from './state/restoreContactsState';
import type HardDeleteState from './state/hardDeleteState';
import type PdlEmailsPickerState from './state/pdlEmailsPickerState';
import type { MoveContactsState } from './state/moveContactsState';
import type { FavoritePickerState } from './state/favoritePickerState';
import type { DeletedItemsFolderState } from './state/deletedItemsFolderState';
import type { GroupsState } from './state/groupsState';

export interface HubViewState {
    readonly deletePersonaState: DeletePersonaState;
    readonly personaLinkingState: PersonaLinkingState;
    readonly privateDLLoadingState: PrivateDLLoadingState;
    readonly moveContactsState: MoveContactsState;
    readonly favoritePickerState: FavoritePickerState;
    readonly restoreContactsState: RestoreContactsState;
    readonly hardDeleteState: HardDeleteState;
    readonly deletedItemsFolderState: DeletedItemsFolderState;
    readonly groupsState: GroupsState;
    readonly pdlEmailsPickerState: PdlEmailsPickerState;
}

export interface HubState {
    view: HubViewState;
}

export const packageStateKey = 'hub';
